import React, { useRef, useEffect, useLocation, useContext } from 'react';
import { setupScene } from '../componentes/3d/QPMINI_6_ILUMINADO';
import DotRing from "../componentes/DotRing";
import { MouseContext } from "../contexto/mouse-context";
import { useParams } from 'react-router-dom';


const Producto3D = () => {
    const mountRef = useRef(null);
    const { cursorType, cursorChangeHandler } = useContext(MouseContext)
    const { modelo } = useParams();
    
    useEffect(() => {

    }, [])

     useEffect(() => {
         console.log(modelo);
         const cleanup = setupScene(mountRef, modelo);
         return cleanup;
     }, []);

  /*  useEffect(() => {
        console.log("modelo obtenido--",modelo)
        // Pasar 'modelo' a 'setupScene'
        const cleanup = setupScene(mountRef);
        return cleanup;
    }, [modelo]);*/

    return (
        <div style={{ width: '100%', height: '100vh', backgroundColor: '#F3F1ED' }} onMouseEnter={() => cursorChangeHandler("")}
            onMouseLeave={() => cursorChangeHandler("")}>
            <DotRing />

            <div
                ref={mountRef}
                className='modelo3d'
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                }}
            />


            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 15, borderWidth: 2, borderStyle: 'solid', borderColor: '#5c5c61', position: 'absolute', bottom: 10, left: 10, zIndex: 10, borderRadius: 50 }}>
                <p>Quickpaymini</p>
            </div>

            <div style={{
                position: 'absolute',
                top: '50%',
                right: 30,
                transform: 'translateY(-50%)',
                maxWidth: '20%',
                maxHeight: '90%',
                zIndex: 10,
            }} >
                <p style={{ textAlign: 'center' }}>El Quickpaymini es un cajero para ayudar a negocios pequeños a su administracion y operacion. Olvidate</p>
            </div>

        </div >
    );
};

export default Producto3D;
